module.exports = __webpack_public_path__ + "static/media/visual-dump-team.a082c5df.png";